module.exports = __webpack_public_path__ + "img/buildings.a60a70cc.svg";